export var defaultValue = {
    type: 'test_scenario',
};
export function playModeReducer(playMode, action) {
    if (playMode === void 0) { playMode = defaultValue; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'playMode') {
                return action.message.payload;
            }
    }
    return playMode;
}



//////////////////
// WEBPACK FOOTER
// ./src/containers/ModeChooserTabs/reducers.ts
// module id = 1833
// module chunks = 0